import classNames from "classnames";
import React, { FunctionComponent } from "react";

import { ITestable } from "@/browser";
import { Text } from "@/components/Text";
import { Flex, IBadgeProps } from "@/eworkitComponents";

export interface ISkillBadgeActionProps extends IBadgeProps, ITestable {
  text: string;
  onClick: () => void;
}

export const SkillBadge: FunctionComponent<ISkillBadgeActionProps> = ({ children, text, testName, ...rest }) => {
  const classes = classNames("skill-badge", rest.className);

  return (
    <div {...rest} className={classes}>
      <Flex align="center" wrap="nowrap" innerMargin="sm">
        <Text color="black">{text}</Text>
        {children}
      </Flex>
    </div>
  );
};
